import { render, staticRenderFns } from "./PersonImport.vue?vue&type=template&id=5782e9cb&scoped=true"
import script from "./PersonImport.vue?vue&type=script&lang=js"
export * from "./PersonImport.vue?vue&type=script&lang=js"
import style0 from "./PersonImport.vue?vue&type=style&index=0&id=5782e9cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5782e9cb",
  null
  
)

export default component.exports